// extracted by mini-css-extract-plugin
export default {"countBubble":"CountBubble_countBubble__qGpi3"};